export default "__VITE_ASSET__CDnpDBNu__"